<div class="flex flex-col p-6 gap-6">
  <ep-breadcrumbs>
    <ep-breadcrumb [routerLink]="['/']"><span>Realm</span></ep-breadcrumb>
    <ep-breadcrumb><span>Users</span></ep-breadcrumb>
  </ep-breadcrumbs>

  <div class="flex items-center justify-between">
    <h1>Users</h1>
    <!--    <ep-button color="primary" [routerLink]="['create']">Create User</ep-button>-->
  </div>

  @if (errorMessage) {
    <ep-alert type="toast" variant="alt" color="danger" [center]="true" [bottom]="true">
      <span slot="header">{{ errorMessage }}</span>
    </ep-alert>
  }

  <div class="flex justify-between items-center gap-4">
    <div class="w-full max-w-sm">
      @if (showAdvancedFilters()) {
        <span class="body-sm text-fg-subtle">Editing filters below…</span>
      } @else if (hasAdvancedFilter()) {
        <div class="flex items-center gap-2 flex-wrap">
          <span class="body-sm text-fg-subtle">Filtering by:</span>
          @for (chip of activeFilterChips(); track chip.key) {
            <ep-chip size="small" [clickable]="false" (click)="showFiltersPanel()">
              <span class="whitespace-nowrap">{{ chip.label }}: {{ chip.value }}</span>
              <ep-button
                color="inverted"
                variant="quiet"
                size="tiny"
                (click)="removeFilterField(chip.key); $event.stopPropagation()"
              >
                <svg class="icon icon--small" viewBox="0 -960 960 960" fill="currentColor">
                  <path
                    d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"
                  />
                </svg>
              </ep-button>
            </ep-chip>
          }
          <ep-button color="default" variant="quiet" size="small" (click)="clearFilters()">
            Clear filters
          </ep-button>
        </div>
      } @else {
        <ep-textfield
          variant="search"
          [formControl]="searchControl"
          placeholder="Username, email, first or last name"
          class="flex-grow"
          ngDefaultControl
        >
          <ep-button
            slot="suffix"
            color="default"
            variant="quiet"
            size="tiny"
            (click)="clearSearch()"
          >
            <svg class="icon icon--small" viewBox="0 -960 960 960" fill="currentColor">
              <path
                d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"
              />
            </svg>
          </ep-button>
        </ep-textfield>
      }
    </div>
    <div class="flex gap-2">
      <div style="position: relative; display: inline-block">
        <ep-button
          color="default"
          [variant]="showAdvancedFilters() ? 'default' : 'quiet'"
          (click)="toggleAdvancedFilters()"
        >
          <span>More filters</span>
        </ep-button>
        @if (!showAdvancedFilters() && hasAdvancedFilter()) {
          <ep-indicator position="top-right" color="primary">{{
            activeFilterChips().length
          }}</ep-indicator>
        }
      </div>
      <ep-button (click)="refreshUsers()" [disabled]="isLoading">
        <svg class="icon" viewBox="0 -960 960 960" fill="currentColor">
          <path
            d="M480-160q-134 0-227-93t-93-227q0-134 93-227t227-93q69 0 132 28.5T720-690v-110h80v280H520v-80h168q-32-56-87.5-88T480-720q-100 0-170 70t-70 170q0 100 70 170t170 70q77 0 139-44t87-116h84q-28 106-114 173t-196 67Z"
          />
        </svg>
        <span>Refresh</span>
      </ep-button>
    </div>
  </div>

  @if (showAdvancedFilters()) {
    <div class="flex items-end gap-4 flex-wrap" [formGroup]="filtersForm">
      <ep-textfield
        label="Username"
        formControlName="username"
        placeholder="Contains…"
        ngDefaultControl
      ></ep-textfield>
      <ep-textfield
        label="Email"
        formControlName="email"
        placeholder="e.g. @example.com"
        ngDefaultControl
      ></ep-textfield>
      <ep-textfield
        label="First name"
        formControlName="firstName"
        placeholder="Contains…"
        ngDefaultControl
      ></ep-textfield>
      <ep-textfield
        label="Last name"
        formControlName="lastName"
        placeholder="Contains…"
        ngDefaultControl
      ></ep-textfield>
      <ep-checkbox formControlName="exact" ngDefaultControl>Exact match</ep-checkbox>
      <ep-button color="default" variant="quiet" (click)="clearFilters()">
        Clear filters
      </ep-button>
    </div>
  }

  @if (!isLoading && users.length === 0) {
    <div class="text-center py-8 text-gray-500">No users found</div>
  }

  <!-- Display users as table instead of ep-items -->
  <!-- Click on row to open user edit in sidebar, use the external link button to open in separate page -->
  <div class="overflow-x-auto">
    <table class="w-full table-fixed">
      <colgroup>
        <col class="w-full min-w-[180px]" />
        <col class="w-full min-w-[180px]" />
        <col class="w-1/6 min-w-[120px]" />
        <col class="w-1/5 min-w-[140px]" />
        <col class="w-[80px]" />
        <col class="w-[100px]" />
      </colgroup>
      <thead>
        <tr>
          <th class="text-left"><label>Name</label></th>
          <th class="text-left"><label>Email</label></th>
          <th class="text-left"><label>Created</label></th>
          <th class="text-left"><label>Status</label></th>
          <th><label>Customer</label></th>
          <th class="text-left"><label>Actions</label></th>
        </tr>
      </thead>
      <tbody>
        @for (user of users; track user.id) {
          <tr
            (click)="openUserEdit(user, $event)"
            class="cursor-pointer border-t border-stroke-subtle hover:bg-gray-50"
          >
            <td class="">
              <div class="flex items-center gap-3 min-w-0">
                <!-- Avatar to later show images but for now show the initials or similar in a colored circle -->
                <div
                  class="rounded icon icon--large bg-bg-primary-default text-fg-primary-bolder flex items-center justify-center flex-shrink-0"
                >
                  <span class="icon__text">{{
                    (user.firstName ? user.firstName.charAt(0) : '') +
                      (user.lastName ? user.lastName.charAt(0) : '') ||
                      user.username?.charAt(0) ||
                      '?'
                  }}</span>
                </div>
                <span class="body-sm truncate">{{
                  (user.firstName || '') +
                    (user.firstName && user.lastName ? ' ' : '') +
                    (user.lastName || '') ||
                    user.username ||
                    '-'
                }}</span>
              </div>
            </td>
            <td class="">
              <span class="body-sm truncate block">
                {{ user.email || 'No email' }}
              </span>
            </td>
            <td class="">
              <span class="body-sm whitespace-nowrap">{{
                user.createdTimestamp | date: 'mediumDate'
              }}</span>
            </td>
            <td class="">
              <div class="flex items-center gap-2 flex-wrap">
                @if (isExternalUser(user)) {
                  <ep-chip color="friendly">External</ep-chip>
                }
                @if (!user.enabled) {
                  <ep-chip color="warning">Disabled</ep-chip>
                }
                @if (
                  user?.attributes?.['last-check-customerno']?.[0] == null &&
                  user?.attributes?.['customerno']?.[0] == null &&
                  user?.attributes?.['employee-id']?.[0] == null &&
                  user?.attributes?.['terms_and_conditions']?.[0] == null
                ) {
                  <ep-chip variant="alt" color="warning" title="User hasn't logged in yet"
                    >Inactive</ep-chip
                  >
                }
              </div>
            </td>

            <td class="">
              <div class="flex justify-center">
                @if (
                  user?.attributes?.['last-check-customerno']?.[0] != null &&
                  user?.attributes?.['customerno']?.[0] != null
                ) {
                  <svg viewBox="0 -960 960 960" class="icon icon--small">
                    <path
                      d="m424-296 282-282-56-56-226 226-114-114-56 56 170 170Zm56 216q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"
                    />
                  </svg>
                }
              </div>
            </td>

            <td class="">
              <!-- Action button for direct navigation -->
              <ep-button
                size="small"
                color="default"
                type="quiet"
                [routerLink]="[user.id]"
                (click)="$event.stopPropagation()"
                title="Open in separate page"
              >
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                  ></path>
                </svg>
              </ep-button>
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>

  @if (isLoading) {
    <div class="py-6 flex justify-center items-center gap-3">
      <div class="lds-dual-ring !h-[1em] !w-[1em] text-[1.25rem]"></div>
      <span>Loading users...</span>
    </div>
  }

  @if (!isLoading && users.length > 0) {
    <div class="self-center">
      <ep-pagination
        type="simple"
        [currentPage]="currentPage"
        [totalPages]="totalPages()"
        [pageSize]="pageSize"
        [pageSizeOptions]="pageSizeOptions"
        [totalItems]="totalUsers"
        (change)="onPageChange($event)"
        (page-size-change)="onPageSizeChange($event)"
      >
      </ep-pagination>
    </div>
  }
</div>
